module.exports = __webpack_public_path__ + "static/media/button-matching.f8b97bb7.png";